import type { OptionType } from '@/interfaces/status.interface';
import { CheckCircle2Icon, CircleSlashIcon } from 'lucide-react';

import type { PostFilter } from '../interfaces/posts.interface';

export const QUERY_POST_LIST = 'posts';
export const QUERY_POST_DETAIL = 'post';

export enum POST_TYPE {
  FAQ = 'faq',
  PAGE = 'page',
}

export enum POST_STATUS {
  PUBLISHED = 'published',
  DRAFT = 'draft',
  DELETED = 'deleted',
  REJECTED = 'rejected',
}

export enum POST_ACTION {
  EDIT = 'edit',
  ACTIVE = 'active',
  DEACTIVE = 'deactive',
  BULK_ACTIVE = 'bulk_active',
  BULK_DEACTIVE = 'bulk_deactive',
}

export const POST_DEFAULT_FILTER: PostFilter = {
  search: '',
  page: 1,
  limit: 50,
  status: [],
  type: POST_TYPE.FAQ,
};

export const POST_STATUSES: OptionType[] = [
  {
    label: 'Active',
    value: true,
    textClassName: 'text-green-700',
    bgClassName: 'bg-green-50',
    borderClassName: 'border-green-200',
    activeClassName: 'ring-green-600',
    iconClassName: 'text-green-600',
    icon: CheckCircle2Icon,
  },
  {
    label: 'Deactive',
    value: false,
    textClassName: 'text-amber-500',
    bgClassName: 'bg-amber-500/10',
    borderClassName: 'border-amber-400',
    activeClassName: 'after:bg-amber-400',
    iconClassName: 'text-amber-600',
    icon: CircleSlashIcon,
  },
];
